import BillDateTitleWithTimezone from '@/common/components/BillDateTitleWithTImezone';
import { ShowHeader } from "@/common/components/ShowHeader";
import BillHeaderDropdownActions from '@/features/billingBills/components/HeaderDropdownActions';
import useBillingBill from "@/features/billingBills/hooks/useBillingBill";
import BillingBillsShow from "@/features/billingBills/pages/Show";
import { useParams } from "react-router-dom";
import { Tooltip } from 'react-tooltip';

const ClientBillShow = () => {
  const { billId } = useParams();

  const {
    data: bill,
    isPending: billIsPending,
  } = useBillingBill({ id: billId });

  return (
    <div>
      <ShowHeader
        goBack
        goBackProps={{ fallback: "/client-bills", searchLastRouteFromFallback: true }}
        isLoading={billIsPending}
        title={
          <div className='flex flex-col'>
            <p data-tooltip-id='branch-tooltip' className="text-nowrap max-w-72 overflow-hidden text-ellipsis font-normal">
              {bill?.client_company?.general_information?.fantasy_name}
            </p>

            <Tooltip id="branch-tooltip" place="top-start">
              <div className='flex flex-col'>
                <p>
                  {bill?.client_company?.general_information?.fantasy_name}
                </p>

                <p className="font-light text-sm italic">
                  {bill?.branch_display_name}
                </p>
              </div>
            </Tooltip>
          </div>
        }
        titleClassName="text-md"
        subtitle={(
          <div className='flex items-center gap-1'>
            <p>
              Fatura {bill?.number}
            </p>

            <BillDateTitleWithTimezone
              startDate={bill?.opened_at}
              endDate={bill?.closed_at}
              timezone={bill?.time_zone}
            />
          </div>
        )}
        subtitleClassName="text-nowrap font-medium"
        buttons={<BillHeaderDropdownActions bill={bill} />}
      />

      <BillingBillsShow
        billType="client_bills"
        needSupplyAuthorization={bill?.need_supply_authorization}
        notFoundFallback='/client-bills'
        notFoundButtonText='Ir para Faturas a receber'
      />
    </div>
  );
};

export default ClientBillShow;
